export default __webpack_public_path__ + "static/media/SD-9.6afc541a.jpg";